<template>
  <b-row>
    <form @submit.prevent class="col-12 col-sm-9">
      <b-card class="mb-3" :header="heading" no-body>
        <div class="card-body">
          <b-row>
            <b-form-group class="col-8" label="Name:">
              <b-form-input
                id="tpi-input-name"
                v-model="itemForm.name"
                v-validate="{ required: true, min: 2 }"
                name="tpi-input-name"
                :state="validateState('tpi-input-name')"
                data-vv-as="Name"
              />
              <b-form-invalid-feedback>
                {{ veeErrors.first('tpi-input-name') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group class="col-4" label="Status:">
              <b-v-select
                v-model="itemForm.integrationStatus"
                :options="integrationStatusOpts"
              />
            </b-form-group>

            <b-form-group class="col-6" label="Integration System:">
              <b-v-select
                v-model="itemForm.integrationSystem"
                :options="integrationSystemOpts"
              />
            </b-form-group>

            <b-form-group class="col-6" label="Integration Group:">
              <b-v-select
                v-model="itemForm.integrationGroup"
                :options="integrationGroupOpts"
              />
            </b-form-group>

            <b-form-group class="col-12" label="For Client:">
              <b-v-select
                id="tpi-input-brandId"
                v-model="itemForm.brandId"
                v-validate="{ required: true }"
                :searchable="true"
                name="tpi-input-brandId"
                :state="validateState('tpi-input-brandId')"
                data-vv-as="Client"
                :options="brandsList"
                :disabled="!!(itemForm.id && !is('developer'))"
              />
              <b-form-invalid-feedback>
                {{ veeErrors.first('tpi-input-brandId') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-row>
        </div>
      </b-card>

      <b-card class="mb-3" header="Credentials" no-body>
        <div class="card-body">
          <b-row>
            <b-form-group class="col-12" label="API Key:">
              <b-form-input v-model="itemForm.apiKey" />
            </b-form-group>
          </b-row>
        </div>
      </b-card>
    </form>

    <aside class="col-12 col-sm-3 d-flex flex-column">
      <b-card header="Actions" class="order-last order-sm-first">
        <b-button
          :disabled="savingItem"
          variant="primary"
          block
          @click="SaveForm"
        >
          <span v-if="savingItem">Saving...</span>
          <span v-else>Save Changes</span>
        </b-button>
        <router-link
          class="mt-2 btn btn-block btn-outline-danger"
          :to="{ name: 'Integrations.ThirdPartyApps.Index' }"
        >Cancel</router-link>
      </b-card>
    </aside>
  </b-row>
</template>

<script>
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';

export default {
  name: 'Integrations.ThirdPartyApps.Form',
  mixins: [crudMixinGen('thirdPartyIntegrations'), myCommonDataMixin],

  props: {
    id: {
      type: String,
      default: '',
      required: false
    }
  },

  data: function() {
    return {
      heading: 'Third Party App Integration',
      integrationSystemOpts: [
        { value: 'LoopReturns', text: 'Loop Returns' }
      ],
      integrationGroupOpts: [
        { value: 'OrderReturnsSystem', text: 'Order Returns System' }
      ],
      integrationStatusOpts: [
        { value: 'Active', text: 'Active' },
        { value: 'Paused', text: 'Paused' },
        { value: 'Pending', text: 'Pending' },
        { value: 'PendingClientAction', text: 'Pending Client Action' },
        { value: 'Disabled', text: 'Disabled' }
      ]
    };
  },

  mounted: function() {
    if (this.id) {
      this.ResetForm();
      this.LoadItem(this.id);
    } else {
      this.ResetForm();
    }
  },

  methods: {
    SaveForm: function() {
      var self = this;
      self.savingItem = true;
      self.SaveItem()
      .then(function() {
        self.ResetForm();
        self.$swal('Saved!', 'Third party integration saved successfully.', 'success');
        self.$router.push({ name: 'Integrations.ThirdPartyApps.Index' });
      })
      .catch(function(err) {
        self.savingItem = false;
        var msg = (err.response && err.response.data && err.response.data.errorMessage) || 'Item was not saved.';
        self.$swal('Error', msg, 'error');
      });
    }
  }
};
</script>
